import React, {useEffect, useRef, useState} from "react";
import * as ST from "./styled";
import {List} from "@mui/material";
import SubMenuItem from "../../SubMenuItem";
import SubMenuItemText from "../../SubMenuItemText";
import Colors from "../../../../../../general/constants/colors";
import SubMenuLvl3 from "../SubMenuThirdLevel";
import DataHeaderType from "../../../../../Types/DataHeaderType";

interface SubmenuProps {
	items: DataHeaderType[]
	isVisible: boolean
	subMenuCloseHandler: React.Dispatch<any>
	cancelHideSubMenuHandler: React.Dispatch<any>
}

const SubMenuLvl2: React.FC<SubmenuProps> = ({items, isVisible, subMenuCloseHandler, cancelHideSubMenuHandler}) => {
	const subMenuRef = useRef<HTMLDivElement>(null);
	const [activeSubMenuIndex, setActiveSubMenuIndex] = useState<number | null>(null);

	useEffect(() => {
		if (subMenuRef.current) {
			subMenuRef.current.style.display = isVisible ? 'flex' : 'none';
		}
	}, [isVisible]);

	return (
		<ST.SubMenuContainer
			ref={subMenuRef}
			onMouseEnter={cancelHideSubMenuHandler}
			onMouseLeave={subMenuCloseHandler}
		>
			<List>
				{items.map((item, index) => (
					<SubMenuItem
						key={item.id}
						onMouseEnter={(e) => {
							setActiveSubMenuIndex(index)
						}}
					>
						<SubMenuItemText
							text={item.name}
							sx={{color: index === activeSubMenuIndex ? Colors.GREEN : "inherit"}}
						/>
					</SubMenuItem>
				))}
			</List>
			{activeSubMenuIndex !== null && (items[activeSubMenuIndex]?.children ?? []) && (
				<SubMenuLvl3 items={items[activeSubMenuIndex].children ?? []} />
			)}
		</ST.SubMenuContainer>
	)
}

export default SubMenuLvl2